import { decode as base64_decode } from 'base-64';

/**
 * Plano contratado da conta em sessão.
 *
 * O plano vive em ddesp[8] e chega sempre como string — o backend força
 * strval() ao montar a sessão. Ainda assim a comparação aceita número, que é
 * a prática defensiva já adotada no resto do código.
 *
 * Planos: 1 BASIC · 2 VIP · 3 FREEDOM · 4 ResgateXML · 5 DEMONSTRAÇÃO ·
 * 11 API Master.
 */

/** Conta nova em período de avaliação, atribuída por padrão a todo cadastro. */
export const PLANO_DEMONSTRACAO = '5';

/**
 * Plano da conta em sessão.
 *
 * @return {string} Vazio quando não há sessão.
 */
export const planoAtual = () => {
  try {
    const bruto = sessionStorage.getItem('ddesp');
    if (!bruto) return '';

    const users = JSON.parse(base64_decode(bruto));

    return users?.[8] != null ? String(users[8]) : '';
  } catch {
    return '';
  }
};

/**
 * Informa se a conta está em demonstração.
 *
 * O atendimento dessas contas é feito pelo chat do comercial, não pelo suporte
 * técnico: elas não falam com o TomTicket nem são cadastradas lá.
 *
 * @return {boolean}
 */
export const ehDemonstracao = () => planoAtual() === PLANO_DEMONSTRACAO;

/**
 * Dados da conta e do usuário em sessão, para identificar quem está falando nos
 * canais de atendimento.
 *
 * Os índices seguem a tabela documentada em api/model/dao/acesso_.class.php.
 *
 * @return {object} Campos vazios quando não há sessão.
 */
export const dadosDaConta = () => {
  const vazio = { conta: '', empresa: '', cnpj: '', usuario: '', nome: '', email: '', plano: '' };

  try {
    const bruto = sessionStorage.getItem('ddesp');
    if (!bruto) return vazio;

    const users = JSON.parse(base64_decode(bruto));
    const texto = (v) => (v != null ? String(v) : '');

    return {
      conta: texto(users?.[0]),
      empresa: texto(users?.[1]),
      cnpj: texto(users?.[2]),
      usuario: texto(users?.[3]),
      nome: texto(users?.[4]),
      email: texto(users?.[6]),
      plano: texto(users?.[8]),
    };
  } catch {
    return vazio;
  }
};

export default ehDemonstracao;
